import React from "react";
import "../style/login.scss";
import { Icon } from "@iconify/react";
import { Link } from "react-router-dom";
const Forget = () => {
  return (
    <div className="login-banner">
      <div className="content-left">
        <div className="content-left-mainDiv">
          <p className="content-left-heading">Group LanDev AI</p>
          <span>
            {" "}
            Going to Help to Plan your <br /> <span>Construction</span>
          </span>
        </div>
      </div>

      <div className="content-right">
        <div className="content-right-container">
          <p>Forgot Password!</p>
          <p className="hello-text">
            Enter your email and we will send you a link to reset your password
          </p>
          {/* <div className="input-fields">
        
        <div className="input-field-text">Username</div>
      </div> */}

          <input
            type="Email"
            placeholder=" Enter your email"
            className="input-fields"
          />

          <div
            className="btnWrapper"
            style={{
              display: "flex",
              alignItem: "center",
              justifyContent: "center",
            }}
          >
            <button className="gradient-btn-yellow ">Submit</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Forget;
